import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromModels from '../../models/rootState.model';

export const selectApiState = createFeatureSelector<fromModels.ApiState>('api');

export const selectApiOnline = createSelector(selectApiState, (state) => state.online);
export const selectApiError = createSelector(selectApiState, (state) => state.error);
export const selectApiErrorCount = createSelector(selectApiState, (state) => state.count);
export const selectApiErrorConsecutives = createSelector(selectApiState, (state) => state.consecutives);

